import withSearch, { SearchProps } from "hocs/withSearch";
import { forwardRef } from "react";

import Select from "./Select";

const SearchWithTypeField = forwardRef<
  HTMLInputElement,
  SearchProps & { options: Array<{ label: string; value: string | number }> }
>(({ onKeyDown, onChange, onSearch, options }, ref) => {
  return (
    <>
      <Select name="searchType" options={options} className="!w-[6.938rem]" />
      <input
        ref={ref}
        type="text"
        className="flex-1 rounded-md bg-white h-9 text-14 px-[0.625rem] outline-none"
        onKeyDown={onKeyDown}
        onChange={onChange}
      />
      <button
        type="button"
        onClick={onSearch}
        className="rounded-md h-9 w-[4.5rem] inline-flex justify-center items-center bg-primary text-white text-14"
      >
        검색
      </button>
    </>
  );
});

SearchWithTypeField.displayName = "SearchWithTypeField";

const EnhancedSearchWithTypeField = withSearch(SearchWithTypeField);

export default EnhancedSearchWithTypeField;
